import { SubscriptionSettingsDTO, SubscriptionSettingsExclusionsDTO } from '../api';

export const settingsMock: SubscriptionSettingsDTO = {
  settings: [
    {
      productCode: 'TEST_SELECTABLE',
      productName: 'Produkt 1',
      cmsRef: 'Test',
      subscribed: true,
      type: 'Selectable',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
    {
      productCode: 'AP53_602_00',
      productName: 'Dynamiske IP-adresser 2 stk',
      cmsRef: 'C5360200',
      subscribed: true,
      type: 'Setting',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
    {
      productCode: 'AP69_320_00',
      productName: 'HomeBox',
      cmsRef: 'C6932000',
      subscribed: true,
      type: 'Setting',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
    {
      productCode: 'AP13_355_06',
      productName: 'YouSee Mail',
      cmsRef: 'C1335506',
      subscribed: true,
      type: 'Setting',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },

    {
      productCode: 'AP12_015_10',
      productName: 'Tv-boks',
      cmsRef: 'C1201510',
      subscribed: true,
      type: 'Setting',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [
        {
          productCode: 'EMU_TRACK_TRACE',
          productName: 'EMAIL & SMS',
          cmsRef: 'EMU_TRACK_TRACE',
          subscribed: false,
          type: 'Setting',
          changeCode: null,
          orderId: null,
          orderDate: '0001-01-01T00:00:00',
          settings: [],
        },
      ],
    },
    {
      productCode: 'ODIN_CODE_PARENTALPINCODE',
      productName: 'Pinkode til forældrekontrol',
      cmsRef: 'ODIN_CODE_PARENTALPINCODE',
      subscribed: true,
      type: 'PinTvParentControl',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
    {
      productCode: 'ODIN_CODE_FILMRENTALPINCODE',
      productName: 'Pinkode til betaling af filmleje',
      cmsRef: 'ODIN_CODE_FILMRENTALPINCODE',
      subscribed: true,
      type: 'PinMovieRental',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
  ],
};

export const exclusionsMock: SubscriptionSettingsExclusionsDTO = {
  exclusions: [
    {
      productCode: 'AP53_602_00',
      productName: 'Dynamiske IP-adresser 2 stk',
      cmsRef: 'C5360200',
    },
  ],
};
